import { ChangeDetectionStrategy, Component, DestroyRef, inject, signal } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { MatButtonModule } from '@angular/material/button';
import { WidgetMessageService } from '../../services/widget-message.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

export interface DeleteDialogData {
  id: string
  headerText?: string
  name: string
  itemType: string
  deleteFn(id: string): Observable<unknown>
}

@Component({
  selector: 'pixl-confirm-subject-management',
  templateUrl: 'confirm-dialog.component.html',
  styleUrl: 'confirm-dialog.component.scss',
  imports: [
    MatButtonModule,
    MatDialogActions,
    MatDialogTitle,
    MatDialogContent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmDialogComponent {
  readonly dialogRef = inject(MatDialogRef<ConfirmDialogComponent>);
  private widgetService = inject(WidgetMessageService);
  private destroyRef = inject(DestroyRef);
  public readonly data: DeleteDialogData = inject(MAT_DIALOG_DATA);
  public headerText = signal<string>('');

  constructor() {
    if (this.data.headerText) {
      this.headerText.set(this.data.headerText);
    }
    else {
      this.headerText?.set('Datensatz löschen');
    }
  }

  public abort(): void {
    this.dialogRef.close(false);
  }

  public deleteEntry(): void {
    if (!this.data.deleteFn) {
      this.dialogRef.close(true);
      return;
    }

    let success = false;
    this.data.deleteFn(this.data.id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => {
          this.widgetService.setMessage({
            message: 'Datensatz erfolgreich gelöscht',
            messageTye: 'mtSuccess'
          });
          success = true;
        },
        error: () => {
          // message displayed by httpInterceptor
          success = false;
        },
        complete: () => {
          this.dialogRef.close(success);
        }
      });
  };
}
